var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewSubmissionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    clipPath: "url(#NewSubmissionIcon_svg__clip0_3802_944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.895 4.79c2.207-2.167 5.612-2.425 8.105-.773 2.492-1.652 5.898-1.394 8.105.774a6.29 6.29 0 010 8.998l-6.704 6.583a2 2 0 01-2.802 0l-6.704-6.583a6.29 6.29 0 010-8.998zm2.802 2.855a2.482 2.482 0 013.455 0l.447.439a2 2 0 002.802 0l.447-.44a2.482 2.482 0 013.455 0 2.29 2.29 0 010 3.29L26 16.143l-5.303-5.207a2.29 2.29 0 010-3.29zM1.625 36.91A2.004 2.004 0 010 34.907v-5.962c0-5.918 5.414-10.357 11.217-9.196l7.156 1.431A7 7 0 0124 28.033l6.525-2.51a7.503 7.503 0 018.552 2.316 3.834 3.834 0 01-1.437 5.9l-12.872 5.72a12 12 0 01-7.346.777L1.625 36.91zm8.808-13.239C7.105 23.006 4 25.551 4 28.945v4.377l14.247 3a8 8 0 004.897-.518l12.669-5.631a3.503 3.503 0 00-3.853-.916l-9.237 3.553-.035.013a1.99 1.99 0 01-1.11.077l-9.97-1.994a2 2 0 11.784-3.922L20 28.505v-.46a3 3 0 00-2.412-2.943l-7.155-1.43z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "NewSubmissionIcon_svg__clip0_3802_944"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .945)",
    d: "M0 0h40v40H0z"
  })))));
}

export default SvgNewSubmissionIcon;